/* eslint-disable no-mixed-operators */
import { node } from "~/util/dom";
import WZoom from "vanilla-js-wheel-zoom";

export function thumbPosition(data, thumbCont, prevScale) {
	if (data.currentScale === prevScale && data.currentScale === data.minScale) {
		return;
	}

	thumbCont.classList[data.currentScale === data.minScale ? "remove" : "add"]("show");

	const win = { w: data.$element.parentNode.offsetWidth, h: data.$element.parentNode.offsetHeight };
	const img = thumbCont.querySelector("img.clip");
	const thumb = thumbCont.querySelector("div");
	const THUMB_WIDTH = img.offsetWidth;
	const THUMB_HEIGHT = img.offsetHeight;
	const diferenceW = data.currentWidth - win.w;
	const diferenceH = data.currentHeight - win.h;
	const percW = win.w / data.currentWidth;
	const percH = win.h / data.currentHeight;
	const ratioW = THUMB_WIDTH / data.currentWidth;
	const ratioH = THUMB_HEIGHT / data.currentHeight;
	let transL = 0;
	let transT = 0;
	let thumbW = Math.floor(diferenceW >= 1 ? percW * THUMB_WIDTH : THUMB_WIDTH);
	let thumbH = Math.floor(diferenceH >= 1 ? percH * THUMB_HEIGHT : THUMB_HEIGHT);

	// postion top and correction height
	if (Math.abs(win.h - data.currentHeight - data.correctY*2) > data.correctY) {
		const shift = Math.abs(win.h/2 - (data.currentHeight/2 + data.correctY));
		const borderLine = Math.abs(((data.currentHeight + 2 * data.correctY) - win.h) / 2 - data.correctY);
		const direction = data.currentTop < 0 ? 1 : -1;

		if (shift < data.correctY) {
			if (Math.abs(data.currentTop) + shift < data.correctY) {
				transT = 0;
			} else {
				transT = (Math.abs(data.currentTop) + shift - data.correctY) * ratioH * direction;
			}
		} else {
			transT = data.currentTop * ratioH * -1;
		}

		if (Math.abs(data.currentTop) > borderLine) {
			const correction = (Math.abs(data.currentTop) - borderLine) * ratioH;

			transT -= correction / 2 * direction;
			thumbH -= correction;
		}
	}

	// position left and correction width
	if (Math.abs(win.w - data.currentWidth - data.correctX*2) > data.correctX) {
		const shift = Math.abs(win.w/2 - (data.currentWidth/2 + data.correctX));
		const borderLine = Math.abs(((data.currentWidth + 2 * data.correctX) - win.w) / 2 - data.correctX);
		const direction = data.currentLeft < 0 ? 1 : -1;

		if (shift < data.correctX) {
			if (Math.abs(data.currentLeft) + shift < data.correctX) {
				transL = 0;
			} else {
				transL = (Math.abs(data.currentLeft) + shift - data.correctX) * ratioW * direction;
			}
		} else {
			transL = data.currentLeft * ratioW * -1;
		}

		if (Math.abs(data.currentLeft) > borderLine) {
			const correction = (Math.abs(data.currentLeft) - borderLine) * ratioW;

			transL -= correction / 2 * direction;
			thumbW -= correction;
		}
	}

	transT = Math[transL > 0 ? "ceil" : "floor"](transT);
	transL = Math[transL > 0 ? "floor" : "ceil"](transL);

	if ((thumbH / 2 + transT) * 2 > THUMB_HEIGHT) {
		thumbH--;
	}

	if ((thumbW / 2 + transL) * 2 > THUMB_WIDTH) {
		thumbW--;
	}

	thumb.style.width = `${Math.floor(thumbW)}px`;
	thumb.style.height = `${Math.floor(thumbH)}px`;
	thumb.style.transform = `translate3d(${transL}px, ${transT}px, 0)`;
	const clip = {
		top: Math.floor(Math.abs((thumbCont.offsetHeight - thumbH) / 2 + transT)),
		right: Math.ceil(Math.abs(thumbCont.offsetWidth - (thumbCont.offsetWidth - thumbW) / 2 + transL)),
		bottom: Math.ceil(Math.abs(thumbCont.offsetHeight - (thumbCont.offsetHeight - thumbH) / 2 + transT)),
		left: Math.floor(Math.abs((thumbCont.offsetWidth - thumbW) / 2 + transL)),
	};

	img.style.clip = `rect(${clip.top}px, ${clip.right}px, ${clip.bottom}px, ${clip.left}px)`;
}

export function createThumb(url) {
	const cont = node("div", { className: "zoom-thumb" });
	const thumbImg = node("img", { src: Mapy.CDN.setSize(url, Mapy.CDN.SIZE_160_130) });
	const thumbImgClip = thumbImg.cloneNode() as HTMLImageElement;

	thumbImgClip.classList.add("clip");
	cont.appendChild(thumbImg);
	cont.appendChild(thumbImgClip);
	cont.appendChild(node("div"));

	return cont;
}

export function create(data, imgCont, contentSelector, thumbCont) {
	const clip = thumbCont.querySelector("img.clip");
	const div = thumbCont.querySelector("div");
	let prevScale = 0;

	//debugger;

	const WZ = WZoom.create(contentSelector, {
		type: "html",
		width: data.width,
		height: data.height,
		zoomOnClick: false,
		speed: 1.25,
		smoothTime: 0.000001,
		dragScrollableOptions: {
			onGrab: () => {
				imgCont.classList.add("grabbing");
				thumbCont.classList.add("no-trans");
			},
			onDrop: () => {
				requestAnimationFrame(() => {
					imgCont.classList.remove("grabbing");
				});
				thumbCont.classList.remove("no-trans");
				thumbPosition(WZ.content, thumbCont, prevScale);
				prevScale = WZ.content.currentScale;
			},
			onMove: () => {
				thumbPosition(WZ.content, thumbCont, prevScale);
				prevScale = WZ.content.currentScale;
			},
		},
		prepare: () => {
			const ratio = data.width/data.height;
			const size = { width: 135, height: 130 };
			const scaleW = size.width / data.width;
			const scaleH = size.height / data.height;
			const borders = { x: 0, y: 0 };

			// napocitame velikost plovouciho rozmeru sirky
			if (ratio >= 1) {
				size.height = data.height * scaleW;
			// napocitame velikost plovouciho rozmeru vysky
			} else {
				size.width = data.width * scaleH;
			}

			clip.style.clip = `rect(0, ${size.width}px, ${size.height}px, 0)`;
			div.style.width = `${size.width + Math.round(borders.x) * scaleW}px`;
			div.style.height = `${size.height + Math.round(borders.y) * scaleH}px`;
			div.style.transform = ``;
			thumbCont.style.width = `${size.width + Math.round(borders.x) * scaleW}px`;
			thumbCont.style.height = `${size.height + Math.round(borders.y) * scaleH}px`;
		},
		rescale: () => {
			setTimeout(() => {
				thumbPosition(WZ.content, thumbCont, prevScale);
				prevScale = WZ.content.currentScale;
			}, 0);
		},
	});

	return WZ;
}
